import { render } from "./BimPlusViewer.vue?vue&type=template&id=c24d1142&scoped=true"
import script from "./BimPlusViewer.vue?vue&type=script&lang=js"
export * from "./BimPlusViewer.vue?vue&type=script&lang=js"

import "./BimPlusViewer.vue?vue&type=style&index=0&id=c24d1142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24d1142"]])

export default __exports__